import { render, staticRenderFns } from "./ButtonCloseBuyer.vue?vue&type=template&id=71b60756&"
import script from "./ButtonCloseBuyer.vue?vue&type=script&lang=ts&"
export * from "./ButtonCloseBuyer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports